var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"py-28 text-muted"},[_vm._v("© Saas1C. Все права защищены. 2019")])}
var staticRenderFns = []

export { render, staticRenderFns }